import { JobAssignment } from '@th-types/job.detail.type';

// Enum values match API contract
export enum AvailabilityType {
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  ADDRESS_CHANGE = 'ADDRESS_CHANGE',
  WORK = 'WORK',
}

// Display labels for UI (if needed in future)
export const AvailabilityTypeLabels: Record<AvailabilityType, string> = {
  [AvailabilityType.NOT_AVAILABLE]: 'Not Available to Work',
  [AvailabilityType.ADDRESS_CHANGE]: 'Address Change',
  [AvailabilityType.WORK]: 'TH Work Engagement',
};

export interface IAvailabilityData {
  id: string;
  workerId: number;
  from: string;
  to: string;
  type: AvailabilityType;
  allDay: boolean;
  jobAssignment?: JobAssignment;
}

export interface IWorkerAvailabilityData {
  workerAvailabilities: IAvailabilityData[];
}
